import { CheckboxInput } from '@rocketmakers/armstrong';
import * as React from 'react';
import './confirm-action.scss';

export const ConfirmAction: React.FunctionComponent<{
  actionConfirmed: boolean;
  setActionConfirmed: () => void;
  message: string;
}> = ({ actionConfirmed, setActionConfirmed, message }) => {
  return (
    <div className="confirm-action">
      <CheckboxInput
        data-qa="checkbox-continue"
        key={'confirm-action-checkbox'}
        labelContent={message}
        checked={actionConfirmed}
        onChange={() => setActionConfirmed()}
      />
    </div>
  );
};
